module.exports = __webpack_public_path__ + "static/media/client-side-deployment.cc0d1a3f.jpg";